"use client";

import React from "react";
import { motion } from "framer-motion";

const leadSentence =
  "Founded by IFMGA-certified mountain guide Prem Gurung, Infinity Adventure Nepal is dedicated to crafting extraordinary mountaineering expeditions and trekking adventures in the world's greatest mountain range.";

export default function HomeAboutUs() {
  const words = leadSentence.split(" ");

  return (
    <section className="w-full bg-white py-16 md:py-24 relative overflow-hidden">
      <div className="lg:w-11/12 w-11/12 3xl:w-8/12 mx-auto flex flex-col items-center">
        {/* Section Title */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="text-center mb-6 md:mb-8"
        >
          <h2 className="font-extrabold uppercase lg:text-6xl md:text-4xl sm:text-3xl text-2xl title text-zinc-900 tracking-tight">
            About Us
          </h2>
        </motion.div>

        {/* Dynamic Lead Text Reveal Animation */}
        <motion.p
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-60px" }}
          variants={{
            hidden: { opacity: 0 },
            visible: {
              opacity: 1,
              transition: {
                staggerChildren: 0.025,
                delayChildren: 0.1,
              },
            },
          }}
          className="text-zinc-600 text-base sm:text-lg md:text-xl lg:text-2xl leading-relaxed text-center max-w-4xl mx-auto font-normal"
        >
          {words.map((word, index) => {
            const isHighlight =
              word.includes("Prem") ||
              word.includes("Gurung") ||
              word.includes("Infinity") ||
              word.includes("Adventure") ||
              word.includes("Nepal");

            return (
              <motion.span
                key={index}
                variants={{
                  hidden: { opacity: 0, y: 14 },
                  visible: {
                    opacity: 1,
                    y: 0,
                    transition: { duration: 0.45, ease: "easeOut" },
                  },
                }}
                className={`inline-block mr-1.5 ${
                  isHighlight ? "font-semibold text-zinc-900" : "text-zinc-600"
                }`}
              >
                {word}
              </motion.span>
            );
          })}
        </motion.p>

        {/* Secondary Paragraph Reveal */}
        <motion.p
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.7, delay: 0.35, ease: "easeOut" }}
          className="text-zinc-600 text-base sm:text-lg md:text-xl lg:text-2xl leading-relaxed text-center max-w-4xl mx-auto mt-8 font-normal"
        >
          With over 12 years of experience leading explorers through iconic
          routes like Everest Base Camp, Annapurna Circuit, and technical
          peaks, we ensure every journey delivers unmatched safety, authentic
          local culture, and memories that last a lifetime.
        </motion.p>

      </div>
    </section>
  );
}
